/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "ca-central-1",
    "aws_cloud_logic_custom": [
        {
            "name": "weWatchRest",
            "endpoint": "https://ilaxfpzeo2.execute-api.ca-central-1.amazonaws.com/wewa",
            "region": "ca-central-1"
        }
    ],
    "aws_appsync_graphqlEndpoint": "https://xc5pgvcmvfg4ldzovennnudh7q.appsync-api.ca-central-1.amazonaws.com/graphql",
    "aws_appsync_region": "ca-central-1",
    "aws_appsync_authenticationType": "AMAZON_COGNITO_USER_POOLS",
    "aws_appsync_apiKey": "da2-auvkglirifgwljbisp7lpo4l2a",
    "aws_cognito_identity_pool_id": "ca-central-1:e0405a5c-a758-438b-83bc-bdd196013b9e",
    "aws_cognito_region": "ca-central-1",
    "aws_user_pools_id": "ca-central-1_m6vdG5SdW",
    "aws_user_pools_web_client_id": "5rpecsjf6juodo934preuunh4o",
    "oauth": {},
    "aws_cognito_username_attributes": [
        "EMAIL"
    ],
    "aws_cognito_social_providers": [],
    "aws_cognito_signup_attributes": [
        "EMAIL"
    ],
    "aws_cognito_mfa_configuration": "OPTIONAL",
    "aws_cognito_mfa_types": [
        "SMS"
    ],
    "aws_cognito_password_protection_settings": {
        "passwordPolicyMinLength": 8,
        "passwordPolicyCharacters": []
    },
    "aws_cognito_verification_mechanisms": [
        "EMAIL"
    ],
    "aws_user_files_s3_bucket": "wewatchassets100226-wewa",
    "aws_user_files_s3_bucket_region": "ca-central-1"
};


export default awsmobile;
